export {default as LogoDesktop} from './logo-desktop.svg'
export {default as LogoMobile} from './logo-mobile.svg'
export {default as LogoDesktopDark} from './logo-desktop-dark.svg'
// Let's not import png or jpeg images here, please.
